<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="t_name">
    <p class="cn">目录</p>
  </div>
  <div class="contents">contents</div>
  <p class="detail">
    本报告所依赖数据都来自于线上或线下真实发生的行为所产生的数据，本次用于生成报告的数据为
    {{ taskSum }} 份。
  </p>
  <div class="item" v-for="({ title, child }, index) in catalogue" :key="index">
    <div class="title">
      <div class="index">{{ `${index + 1}`.padStart(2, '0') }}</div>
      <div class="name">{{ title }}</div>
    </div>
    <div class="child" v-if="Array.isArray(child)">
      <div
        class="child-item"
        v-for="({ title, num }, childIndex) in child"
        :key="childIndex"
      >
        <p class="child-item-name">{{ title }}</p>
        <div class="hr"></div>
        <p class="child-item-number">
          {{ `${num}`.padStart(2, '0') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="tsx">
import { watch } from 'vue';
type CataLogueType = Array<{
  title: string;
  num: number;
  child: CataLogueType;
}>;
const props = withDefaults(
  defineProps<{ taskSum?: number; catalogue: CataLogueType }>(),
  {
    taskSum: 1
  }
);
const emits = defineEmits(['catalogueFinish']);
watch(
  () => props.catalogue,
  () => {
    emits('catalogueFinish');
  }
);
</script>
<style lang="scss" scoped>
@import './index.scss';
$left: var(--custom-page-left);
.contents {
  $left: 88px;
  position: absolute;
  font-size: 28px;
  font-weight: 600;
  color: var(--theme-color-1);
  text-align: right;
  border-bottom: 6px solid var(--theme-color-1);
  margin: 0 $left;
  left: 0;
  bottom: 90px;
  width: calc(100% - $left * 2);
  text-transform: uppercase;
}
.top {
  position: absolute;
  top: 0;
  left: $left;
  padding-top: 30px;
}
.t_name {
  position: absolute;
  left: 90px;
  top: 0;
  width: 97px;
  height: 290px;
  background-color: var(--theme-color-1);
  padding-top: 80px;
  .cn {
    font-size: 50px;
    font-weight: 500;
    color: #fff;
    writing-mode: vertical-lr;
    letter-spacing: 48px;
    line-height: 90px;
  }
}
.detail {
  padding-bottom: 48px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.6;
  color: #3e3e3e;
  padding-right: 24px;
}

.item {
  $height: 70px;
  margin-right: 80px;
  .title {
    display: flex;
    align-items: center;
    height: $height;
    box-sizing: border-box;
    position: relative;
    background: #f0efef;
    &::after {
      content: '';
      width: 12px;
      height: 100%;
      background-color: var(--theme-color-1);
      opacity: 0.7;
      position: absolute;
      right: 0;
      top: 0;
    }
    .index {
      text-align: center;
      color: #fff;
      font-size: 32px;
      font-weight: 500;
      height: $height;
      width: $height;
      line-height: $height;
      flex-shrink: 0;
      background-color: var(--theme-color-1);
    }
    .name {
      font-size: 30px;
      font-weight: 500;
      line-height: 69px;
      padding: 0 18px;
      color: #222222;
      @include line_clamp(1);
    }
  }
  .child {
    padding: 28px 0;
    .child-item {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      color: #222222;
      padding: 10px 0;
    }
    .hr {
      flex-grow: 1;
      margin-left: 18px;
      margin-right: 6px;
      border-bottom: 1pt dashed #142666;
    }
    .child-item-name {
      max-width: 60%;
      @include line_clamp(1);
    }
    .child-item-number {
    }
  }
}
</style>
